export * from "./logo-black"